'use client';

import { useEffect, useMemo } from 'react';
import localforage from 'localforage';
import { useLocale } from 'next-intl';
import { useCurrencyStore } from '@/features/shared/currency-store';
import { LocaleCode } from '@/i18n/locales';
import { currencySelectors } from '@/features/currency-selector/state/currency-selectors';
import { buildSiteInformation } from '@/features/games-app-bridge/internal/util/build-site-information';
import { useUser } from '@/features/auth/shared/hooks/use-user';

/**
 * This component is on the root layout.
 * It writes information to the local storage for the games-app-ui.
 * Maybe this isn't needed but we leave it in for now.
 * The games-app uses this infomation to:
 *  - have the navigation links in its own UI point to the correct pages
 *  - get a JWT from the website to call backendservice in AWS (and GCP)
 *  - get the logged in user information
 *
 * @component
 */
export const SiteSettingsSync = () => {
  const storage = useMemo(() => localforage.createInstance({ storeName: 'global' }), []);
  const { loading, authenticatedUser } = useUser();

  const locale = useLocale() as LocaleCode;
  const currency = useCurrencyStore(currencySelectors.currency);
  useEffect(() => {
    if (!loading) {
      const siteInformation = buildSiteInformation(authenticatedUser, locale, currency);

      (async () => {
        await storage.setItem('wtExtra', siteInformation);
      })();
    }
  }, [loading, authenticatedUser, locale, currency, storage]);

  return null;
};
